// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__SsR0v","bigColWidth":"Table_bigColWidth__3bnjU","biggerColWidth":"Table_biggerColWidth__9dyQp","row":"Table_row__LDuQH","col":"Table_col__SH4k5"};